var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E9E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4544 19.43C16.1183 19.0482 15.9515 18.5737 15.9515 18.0091C15.9515 17.7625 15.9807 17.4815 16.0389 17.1714C16.0971 16.8586 16.1606 16.5564 16.2241 16.2621C16.2877 15.9679 16.3326 15.7796 16.3565 15.6975C16.4491 15.2866 16.5391 14.881 16.6211 14.4807C16.7031 14.0804 16.7455 13.757 16.7455 13.5104C16.7455 12.9113 16.5338 12.6091 16.1103 12.6091C15.8033 12.6091 15.5334 12.7602 15.3005 13.0598C15.065 13.3593 14.8771 13.7517 14.7368 14.2341L13.538 19.9019H11L12.8684 11.0716H15.4064L15.2132 11.9888C15.8007 11.3287 16.4888 11 17.2748 11C17.8729 11 18.3493 11.1644 18.7012 11.4931C19.0532 11.8218 19.2305 12.3228 19.2305 12.9935C19.2305 13.3355 19.1882 13.7146 19.1061 14.1308C19.0241 14.5496 18.905 15.0586 18.7542 15.6577C18.6589 16.0235 18.5742 16.3788 18.4975 16.726C18.4207 17.0733 18.3837 17.3463 18.3837 17.5478C18.3837 17.7838 18.4366 17.9667 18.5424 18.0939C18.6483 18.2238 18.8309 18.2874 19.0876 18.2874C19.4396 18.2874 19.7228 18.1602 19.9345 17.9083C20.1462 17.6565 20.3579 17.2642 20.5696 16.734H21.3107C20.8766 18.0276 20.3738 18.8971 19.8048 19.3372C19.2358 19.7773 18.6457 19.9999 18.0343 19.9999C17.3171 19.9999 16.7931 19.8091 16.457 19.4273L16.4544 19.43Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2258 21.3658C23.9092 20.4092 25.0269 20 26.1632 20C27.2995 20 29 20.3252 29 23.5528V28.9999H26.4625V23.9783C26.4625 23.1246 26.3804 21.7425 25.0269 21.7425C23.3583 21.7425 23.3238 23.7398 23.3238 24.1165V28.9999H20.7864V20.3252H23.2232V21.3658H23.2258Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandDefault);
export default __webpack_public_path__ + "static/media/brand-default.c53e95f717166866e448e79a088ac93e.svg";
export { ForwardRef as ReactComponent };